// HR-facing org settings — GET/PATCH /api/hr/settings. Org profile fields
// (name, headcount band, primary/escalation contacts) are captured once at
// signup/onboarding (`SignupRequestSchema` / `HrOnboardingSchema` in
// `./signup.ts`) and were previously never editable again; this is the
// first HR-facing surface for them. The `privacy` block is read-only here —
// changing the amber-aggregation threshold stays a BesideU_Admin-only
// support action (`PATCH /api/admin/orgs/:id/settings`).

import { z } from 'zod';
import {
  headcountBandSchema,
  orgContactSchema,
  type HeadcountBand,
  type OrgContact,
} from './signup.ts';

export const UpdateOrgProfileSchema = z.object({
  name: z.string().trim().min(2).max(120),
  headcountBand: headcountBandSchema,
  primaryContact: orgContactSchema,
  escalationContact: orgContactSchema,
});
export type UpdateOrgProfileRequest = z.infer<typeof UpdateOrgProfileSchema>;

export interface HrSettingsResponse {
  organization: {
    name: string;
    headcountBand: HeadcountBand | null;
    primaryContact: OrgContact | null;
    escalationContact: OrgContact | null;
  };
  privacy: {
    amberAggregationMinPool: {
      effective: number;
      source: 'override' | 'env' | 'fallback';
    };
  };
}
